import React, { useEffect, useState } from "react";
import { api } from "../../api/client";

type Option = { id: string; label: string; sort_order: number };

export default function Settings() {
  const [options, setOptions] = useState<Option[]>([]);
  const [newLabel, setNewLabel] = useState("");
  const [rsvpBy, setRsvpBy] = useState("");
  const [status, setStatus] = useState<string | null>(null);

  async function loadAll() {
    const [o, s] = await Promise.all([
      api.get<{ options: Option[] }>("/api/admin/options"),
      api.get<{ settings: Record<string, string> }>("/api/admin/settings"),
    ]);
    setOptions(o.options);
    setRsvpBy(s.settings["rsvp_by_date"] ?? "");
  }

  useEffect(() => {
    void loadAll();
  }, []);

  async function addOption(e: React.FormEvent) {
    e.preventDefault();
    if (!newLabel.trim()) return;
    await api.post("/api/admin/options", {
      label: newLabel.trim(),
      sortOrder: options.length,
    });
    setNewLabel("");
    await loadAll();
  }

  async function renameOption(id: string, label: string) {
    await api.put(`/api/admin/options/${id}`, { label });
    await loadAll();
  }

  async function deleteOption(id: string) {
    if (!window.confirm("Delete this dinner option?")) return;
    await api.del(`/api/admin/options/${id}`);
    await loadAll();
  }

  async function saveRsvpBy(e: React.FormEvent) {
    e.preventDefault();
    await api.put("/api/admin/settings", {
      settings: { rsvp_by_date: rsvpBy },
    });
    setStatus("Saved!");
    setTimeout(() => setStatus(null), 2000);
  }

  return (
    <div className="admin general">
      <header className="admin-header">
        <h1 className="admin-heading">General settings</h1>
      </header>

      <section className="general-settings">
        <h2>RSVP-by date</h2>
        <form onSubmit={saveRsvpBy} className="admin-form cutoff">
          <label>
            Deadline
            <input
              type="date"
              value={rsvpBy}
              onChange={(e) => setRsvpBy(e.target.value)}
            />
          </label>
          <div className="form-actions">
            <button className="button" type="submit">
              Save
            </button>
            {status && <span className="success">{status}</span>}
          </div>
        </form>
      </section>

      <section className="options-heading">
        <h2>Dinner options</h2>
        <ul className="option-list">
          {options.map((o) => (
            <li key={o.id} className="option-form">
              <input
                defaultValue={o.label}
                onBlur={(e) => {
                  const v = e.target.value.trim();
                  if (v && v !== o.label) renameOption(o.id, v);
                }}
              />
              <button className="delete" onClick={() => deleteOption(o.id)}>
                Delete
              </button>
            </li>
          ))}
          {options.length === 0 && (
            <li className="muted">No options yet.</li>
          )}
        </ul>

        <form onSubmit={addOption} className="admin-form">
          <label>
            New option
            <input
              value={newLabel}
              onChange={(e) => setNewLabel(e.target.value)}
              placeholder="e.g. Salmon"
            />
          </label>
          <div className="form-actions">
            <button className="button" type="submit">
              Add
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}
